// ── VERSIONES: qué módulos incluye cada versión ──────────────────────────────
const VERSIONES = {
  premium: {
    modulos: {
      calendario: true,
      pacientes: true,
      profesionales: true,
      finanzas: true,
      configuracion: true,
    },
  },
  freemium: {
    modulos: {
      calendario: true,
      pacientes: false,
      profesionales: false,
      finanzas: false,
      configuracion: true, // solo sección WhatsApp
    },
  },
};

// ── MODOS: comportamiento del sistema ────────────────────────────────────────
const MODOS = {
  profesional: {
    // Consultorio autoadministrado: un profesional con permisos completos (sin admin separado).
    // "Profesionales" muestra solo su propio perfil.
    multiProfesional: false,
    autoadministrado: true,
  },
  clinica: {
    // Admin de clínica gestiona múltiples profesionales.
    multiProfesional: true,
    autoadministrado: false,
  },
};

// ── CLIENTES: configurar aquí cada cliente ───────────────────────────────────
export const CLIENTES = {
  ariel: { nombre: "Ariel", version: "premium", modo: "profesional" },
  romi: { nombre: "Romi", version: "premium", modo: "profesional" },
  dai: { nombre: "Dai", version: "freemium", modo: "profesional" },
};

// ── Helper: devuelve config completa para un cliente ─────────────────────────
export function getClientConfig(clientId) {
  const cliente = CLIENTES[clientId] ?? CLIENTES.ariel;
  return {
    clientId,
    ...cliente,
    ...VERSIONES[cliente.version],
    ...MODOS[cliente.modo],
  };
}
